import { Breadcrumbs, ButtonBase } from '@mui/material';
import React from 'react';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import { BreadcrumbChevron } from './BreadcrumbChevron';

export interface ButtonBreadcrumbItem {
  title: string;
  id: string;
  onClick?: () => void;
}

interface Props {
  items: ButtonBreadcrumbItem[];
  maxItems?: number;
}

export const ButtonBreadcrumbs: React.FC<Props> = ({ items, maxItems }) => {
  return (
    <Breadcrumbs separator={<BreadcrumbChevron />} sx={{ px: 2 }} maxItems={maxItems}>
      {items.map(({ title, id, onClick }, index) => {
        const isLast = index === items.length - 1;
        const sx: SystemStyleObject = isLast
          ? { color: 'text.primary', cursor: 'default' }
          : {
              color: 'text.secondary',
              '&:hover': { textDecoration: 'underline' },
            };
        return (
          <ButtonBase key={id} sx={{ fontSize: '16px', fontWeight: 600, ...sx }} onClick={onClick}>
            {title}
          </ButtonBase>
        );
      })}
    </Breadcrumbs>
  );
};
